import { render, staticRenderFns } from "./RequestPay.vue?vue&type=template&id=2bd35455"
import script from "./RequestPay.vue?vue&type=script&lang=js"
export * from "./RequestPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports